import { motion } from "framer-motion";
import { ArrowRight, Users, Shield, FileCheck } from "lucide-react";
import { GlowButton } from "@/components/ui/GlowButton";
import { Link } from "react-router-dom";

export const CTA = () => {
  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background effects */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-t from-background via-card/50 to-background" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[500px] w-[500px] bg-radial-glow opacity-30" />
      </div>

      <div className="container relative mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-3xl mx-auto text-center"
        >
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
            Don't let{" "}
            <span className="text-cream">narrative</span> cost you millions
          </h2>
          <p className="text-lg text-muted-foreground mb-8 max-w-xl mx-auto">
            Before your next technology acquisition, get the independent due diligence 
            that reveals what's really under the hood. Our team is ready to help.
          </p>

          <div className="flex flex-wrap justify-center gap-4 mb-12">
            <Link to="/auth">
              <GlowButton size="lg">
                Request an engagement
                <ArrowRight className="h-5 w-5" />
              </GlowButton>
            </Link>
            <Link to="/sample-report">
              <GlowButton variant="ghost" size="lg">
                View sample report
              </GlowButton>
            </Link>
          </div>

          {/* Trust badges */}
          <div className="flex flex-wrap justify-center gap-8 pt-8 border-t border-border">
            <div className="flex items-center gap-2 text-muted-foreground">
              <Users className="h-5 w-5 text-cream" />
              <span className="text-sm">Senior technologist-led</span>
            </div>
            <div className="flex items-center gap-2 text-muted-foreground">
              <Shield className="h-5 w-5 text-cream" />
              <span className="text-sm">100% independent</span>
            </div>
            <div className="flex items-center gap-2 text-muted-foreground">
              <FileCheck className="h-5 w-5 text-cream" />
              <span className="text-sm">Investment-ready deliverables</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
